export enum TMosaicAction {
  grid = "grid",
  filter = "filter",
  filter_column = "filter_column",
}
